<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">Inhuur mensen</div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>
@if (!selectedWeek) {
    <div mat-dialog-content>
        <h2>Kies een week</h2>
        <table class="table table-bordered table-striped text-right table-hover">
            <thead>
                <tr>
                    <th class="text-center" width="70">Week</th>
                    <th>Van</th>
                    <th>Tot</th>
                </tr>
            </thead>
            @for (week of weeks; track week) {
                <tr class="curpoint" (click)="showHire(week)">
                    <td class="text-center">{{ week.startDate | date: 'w' }}</td>
                    <td>
                        {{ week.startDate | date: 'EEE dd MMM y' }}
                    </td>
                    <td>
                        {{ week.endDate | date: 'EEE dd MMM y' }}
                    </td>
                </tr>
            }
        </table>
        <i>Het is vandaag {{ today | date: 'EEEE dd MMMM y' }}</i>
    </div>
} @else if (selectedWeek) {
    <div mat-dialog-content>
        <div class="d-flex align-items-center">
            <button (click)="selectedWeek = null" color="primary" mat-icon-button tabindex="-1">
                <i class="fas fa-chevron-left"></i>
            </button>
            <h2 class="mb-0">Inhuur week {{ selectedWeek.startDate | date: 'w' }}</h2>
        </div>
        <table class="table table-bordered table-striped text-right table-hover">
            @for (day of planningsPerDay; track day) {
                <ng-container class="curpoint">
                    <tr>
                        <th class="text-left" colspan="2">
                            {{ day.day | date: 'EEEE dd MMMM' }}
                        </th>
                        <th>Aantal</th>
                    </tr>
                    @for (planning of day.plannings; track planning) {
                        @for (planningEntity of planning.planning_hire_people; track planningEntity) {
                            <tr>
                                <td width="120">
                                    {{ planningEntity.begindate | date: 'HH:mm' }}
                                    -
                                    {{ planningEntity.enddate | date: 'HH:mm' }}
                                </td>
                                <td>
                                    {{ entitiesMap.get(planningEntity.entity_id).name }}
                                </td>
                                <td>
                                    {{ planningEntity.count }}
                                </td>
                            </tr>
                        }
                    }
                </ng-container>
            }
        </table>
    </div>
}
